import * as React from 'react';
import { LIST_ROW_HEIGHTS } from '../../../../constants/list_row_heights';
import { IListRowRenderProps, ITeam } from '../../../../data/types';
import { SelectBox } from '../../../shared/form/SelectBox';
import { List } from '../../../shared/List/List';
import { ListAvatar } from '../../../shared/List/ListAvatar';
import { ListItem, ListItemCell } from '../../../shared/List/ListItem';
import { NoResults } from '../../../shared/NoResults';

interface IProps {
  teams: ITeam[];
  selectedTeams: ITeam[];
  onSelect: (team: ITeam, checked: boolean) => void;
  emptyMessage?: string;
}

export const MultiTeamSelectList = (props: IProps): React.ReactElement => {
  /**
   * @description render function for list items
   * @param param0
   */
  const rowRenderer = ({
    index,
    key,
    style,
  }: IListRowRenderProps): React.ReactElement => {
    const row = props.teams[index];
    return (
      <TeamListItem
        style={style}
        team={row}
        key={key}
        onSelect={props.onSelect}
        selected={props.selectedTeams?.includes(row)}
      />
    );
  };

  return props.teams.length ? (
    <List
      rowHeight={LIST_ROW_HEIGHTS.normal}
      rowRenderer={rowRenderer}
      listLength={props.teams.length}
    />
  ) : (
    <NoResults message={props.emptyMessage ?? 'No Teams'} />
  );
};

interface IListItemProps {
  team: ITeam;
  onSelect: (team: ITeam, checked: boolean) => void;
  style: React.CSSProperties;
  selected: boolean;
}

const TeamListItem = (props: IListItemProps): React.ReactElement => {
  const selectionHandler = (
    e: React.SyntheticEvent<HTMLInputElement>
  ): void => {
    const { checked } = e.currentTarget;
    props.onSelect(props.team, checked);
  };
  return (
    <ListItem style={props.style}>
      <ListItemCell>
        <ListAvatar entity={props.team} />
      </ListItemCell>
      <ListItemCell>
        <SelectBox selected={props.selected} onSelect={selectionHandler} />
      </ListItemCell>
    </ListItem>
  );
};
